import React from 'react';

import { Col } from 'antd';
import routePaths from 'config/routes';
import { NextPage } from 'next';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import Link from 'src/components/Link';
import { IRootReducers } from 'src/reducers';
import { IChallengeCheckoutLottery } from 'src/shared/models';

type Props = {
  configCheckoutLottery?: IChallengeCheckoutLottery;
} & ReturnType<typeof mapStateToProps>;

const CheckoutEndPage: NextPage<Props> = ({
  user,
  userPoints,
  configCheckoutLottery,
}): JSX.Element => {
  const { formatMessage } = useIntl();
  // TODO - restringir acceso directo

  if (configCheckoutLottery?.successStepContent) {
    return (
      <Col className="checkout-end lottery">
        <i className="icon icon--process-check" />
        <div
          className="dangerous-container"
          dangerouslySetInnerHTML={{
            __html: configCheckoutLottery.successStepContent,
          }}
        />
        <Link href={routePaths.PAGES.EXPERIENCE}>
          <a className="link-underscore">
            {formatMessage({
              id: 'page.experience.checkout.end.experiences',
            })}
          </a>
        </Link>
      </Col>
    );
  }

  return (
    <Col className="checkout-end">
      <i className="icon icon--process-check" />
      <h3 className="checkout-end__title fs-mask">
        {formatMessage(
          {
            id: 'page.experience.checkout.end.title',
          },
          { userName: user.salesforce.userFirstname }
        )}
      </h3>
      <p className="checkout-end__points">
        <FormattedMessage
          id="page.experience.checkout.end.points"
          values={{
            strong: (chunks: string) => <strong>{chunks}</strong>,
            points: userPoints,
          }}
        />
      </p>
      <h4 className="checkout-end__subtitle">
        {formatMessage({
          id: 'page.experience.checkout.end.subtitle',
        })}
      </h4>
      <Link href={routePaths.PAGES.EXPERIENCE}>
        <a className="link-underscore">
          {formatMessage({
            id: 'page.experience.checkout.end.experiences',
          })}
        </a>
      </Link>
    </Col>
  );
};

const mapStateToProps = (state: IRootReducers) => {
  return {
    user: state.auth.user,
    userPoints: state.auth.userPoints,
  };
};

export default connect(mapStateToProps)(CheckoutEndPage);
